import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../components/Navbar";
import "./styles.css";
import { Card, Col, Row, Statistic } from "antd";

import moment from "moment";

import { Pie } from "@ant-design/plots";

import CardTotal from "./CardTotal";
import CardTotalLastMonth from "./CardTotalLastMonth";
import ListClientes from "./ListClientes";
import CountUp from "react-countup";
const formatter = (value) => <CountUp end={value} separator="," />;

//Data para el grafico pie chart

const data = [
  {
    type: "Materia Prima",
    value: 27,
  },
  {
    type: "Salarios",
    value: 25,
  },
  {
    type: "Socios",
    value: 18,
  },
  {
    type: "Impuestos",
    value: 15,
  },
  {
    type: "Arreglos",
    value: 10,
  },
  {
    type: "Limpieza",
    value: 5,
  },
];

const configPie = {
  appendPadding: 20,
  data,
  angleField: "value",
  colorField: "type",
  radius: 0.6,
  legend: false,
  label: {
    type: "spider",
    labelHeight: 28,
    content: "{name}\n{percentage}",
  },
  interactions: [
    {
      type: "element-selected",
    },
    {
      type: "element-active",
    },
  ],
};

const axiosConfig = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
};

const Overview = () => {
  const [sales, setSales] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [ticketsByDay, setTicketsByDay] = useState([]);
  const [ticketsLastMonth, setTicketsLastMonth] = useState([]);
  const [totalLM, setTotalLM] = useState([]);
  const [qtyLM, setQtyLM] = useState([]);
  const [lastWeek, setLastWeek] = useState([]);

  const firstOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const today = moment().format("YYYY-MM-DD");
  const [startOfWeek, setStartOfWeek] = useState(
    `'${moment(new Date()).subtract(8, "days").format("YYYY-MM-DD")}'`
  );
  const [yesterday, setYesterday] = useState(
    `'${moment(new Date()).subtract(1, "day").format("YYYY-MM-DD")}'`
  );

  const TotalAmountLW = () => {
    let count = 0;

    lastWeek.forEach((e) => {
      count += e.TotalAmount;
    });

    return count;
  };
  // const handleDate = (value) => {
  //   if (value !== null) {
  //     setStartOfWeek(`'${moment(new Date()).day(-8).format("YYYY-MM-DD")}'`);
  //     setYesterday(`'${moment(new Date()).day(-1).format("YYYY-MM-DD")}'`);
  //   } else {
  //     //   props.setData("");
  //   }
  // };

  useEffect(() => {
    axios
      .get("/api/data/todaysales", axiosConfig)
      .then((result) => {
        setSales(result.data[0]);
      })
      .catch((e) => console.log(e));

    axios
      .get("/api/data/todayClientes", axiosConfig)
      .then((result) => {
        setClientes(result.data[0]);
      })
      .catch((e) => console.log(e));
    axios
      .post(
        "/api/data/ticketsByDateRange",
        { from: startOfWeek, to: yesterday },
        axiosConfig
      )

      .then((result) => {
        setLastWeek(result.data[0]);
      })
      .catch((e) => console.log(e));

    axios
      .post(
        "/api/data/ticketsbyday",
        { from: firstOfMonth, to: today },
        axiosConfig
      )
      .then((result) => {
        setTicketsByDay(result.data);
      })
      .catch((e) => console.log(e));

    axios
      .get("/api/data/lastmonth", axiosConfig)
      .then((result) => {
        console.log("resultado last month", result);
        setTicketsLastMonth(result.data);
      })
      .catch((e) => console.log(e));
  }, [startOfWeek, yesterday]);

  // console.log("value of clientes state", clientes);
  // console.log("value of ticketsbyday", ticketsByDay);

  return (
    <div className="container">
      <Navbar />

      <Row gutter={16}>
        <Col span={6}>
          {sales[0] && (
            <CardTotal
              title="Ventas de Hoy"
              amount={sales[0].Total}
              tickets={sales[0].Clientes}
              ticketsByDay={ticketsByDay}
            ></CardTotal>
          )}
        </Col>

        <Col span={5}>
          <Card title="Clientes de Hoy" bordered={true}>
            <ListClientes clientes={clientes} />
          </Card>
        </Col>
        <Col span={8}>
          <Card
            title="Gastos del Mes (from the 1st to present day)"
            bordered={true}
          >
            <Pie {...configPie} autoFit={true} />
          </Card>
        </Col>

        <Col className="sales" span={5}>
          <Card className="card-card" title="La Ultima Semana" bordered={true}>
            <Statistic
              title="Ventas"
              value={TotalAmountLW()}
              // value={props.ticketsLastMonth[0].Qty}
              formatter={formatter}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <CardTotalLastMonth
            title="Mes anterior"
            amount={ticketsLastMonth.Qty}
            ticketsLastMonth={ticketsLastMonth}
            qtyLM={qtyLM}
            totalLM={totalLM}
            setQtyLM={setQtyLM}
            setTotalLM={setTotalLM}
          ></CardTotalLastMonth>
          {/* <Card title="Accounts Receivable" bordered={true}>
            DATA
          </Card> */}
        </Col>
        <Col span={5}>
          <Card title="Accounts Payable" bordered={true}>
            DATA
          </Card>
        </Col>
        <Col span={5}>
          <Card title="Difference" bordered={true}>
            Calculation
          </Card>
        </Col>
      </Row>
    </div>
  );
};
export default Overview;
